<template>
  <div>
    <el-button
      type="primary"
      @click="handleClick()"
      icon="el-icon-circle-plus-outline"
      size="small"
      >添加</el-button
    >
    <el-dialog
      title="添加模板"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="800px"
      v-dialogDrag
    >
      <el-form
        :model="dataObj"
        :rules="rules"
        size="small"
        ref="ruleForm"
        label-position="right"
        label-width="110px"
      >
        <el-form-item label="模板标题" prop="name">
          <el-input
            v-model="dataObj.name"
            placeholder="请输入"
            class="input-width-two"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否公开" prop="isOpen">
          <el-radio-group v-model="dataObj.isOpen">
            <el-radio :label="1">否</el-radio>
            <el-radio :label="0">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="模板语种">
          <el-select
            class="input-width-two"
            v-model="dataObj.templateLanguages"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="(val, key, index) in dropList.templateLanguages"
              :label="val"
              :value="key"
              :key="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板类型">
          <el-select
            class="input-width-two"
            v-model="dataObj.templateType"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="(val, key, index) in dropList.templateType"
              :label="val"
              :value="key"
              :key="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板内容" prop="content">
          <el-input
            :rows="6"
            v-model="dataObj.content"
            placeholder="请输入"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="dialogFormVisible = false"
          v-preventReClick="5000"
          :disabled="disabled"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="checkAdd('ruleForm')"
          v-preventReClick="5000"
          :disabled="disabled"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 新增邮件模板弹窗
 * 功能：填写模板标题、是否公开（radio：1 否 0 是）、语种、类型、内容后提交
 */
import { templateAdd } from "@/api/user";
import { getTemplateRules } from "@/utils/tabelRules";
export default {
  name: "add",
  props: {
    dropList: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      rules: {},
      // 表单数据（标题、公开状态、内容、语种、类型）
      dataObj: {
        isOpen: "",
        name: "",
        content: "",
        templateLanguages: "",
        templateType: "",
      },
      disabled: false,
      // 弹窗显隐
      dialogFormVisible: false,
    };
  },
  methods: {
    /** 打开新增弹窗并重置表单、加载校验规则 */
    handleClick(row) {
      this.$delectObj(this.dataObj);
      this.dialogFormVisible = true;
      Object.assign(this.rules, getTemplateRules());
    },
    /** 表单校验通过后提交新增模板 */
    checkAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          templateAdd(this.dataObj).then((result) => {
            if (result.code == 200) {
              this.dialogFormVisible = false;
              this.$message({
                message: "新增成功",
                type: "success",
              });
              this.$emit("getList");
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>